import React from "react";
import { useTranslation } from "react-i18next";

// A new chat: what to ask, and the question box
export default function EmptyState({ composer }) {
  const { t } = useTranslation();
  return (
    <div className="ak-empty">
      <div className="ak-empty-intro">
        <h2 className="ak-empty-title">{t("What would you like to know about your videos?")}</h2>
        <p className="ak-empty-text">{t("Ask about people, topics and moments across your library. Answers link to the moments they come from.")}</p>
      </div>
      {composer}
    </div>
  );
}
